/* global G */
/* eslint-disable no-unused-vars */
import { curry } from 'lib/util'
import concatQueryParams, { getEscaped } from 'app/_shared/events/search/query/util'

/**
 * Sets the current `query` term to search for requests that have either
 * of the following conditions met:
 * - `organisation` is the current ref `organisation`
 * - `requesterContactOrg` is the current ref `organisation`
 * - `additionalParty` is the current org
 * - `itemInstalledAt` is the current org
 *
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.Component.Spec} component   action component
 * @param {Event|object} event              information about the event that triggered this handler
 * @returns {string}
 */
const requestHasOrganisationOrPartyOrItem = (module, component, event) => {
  const orgId = getEscaped(module[G.MODEL][G.STATE][G.REF])

  const params = {
    type: 'metatype:request',
    and: 'AND (',
    organisation: `organisation:(${orgId})`,
    requesterOrg: `requesterContactOrg:(${orgId})`,
    additionalParty: `OR additionalParty:(${orgId})`,
    itemInstalledAt: `OR itemInstalledAt:(${orgId})`,
    end: ')',
  }

  return concatQueryParams(params)
}

export default curry(requestHasOrganisationOrPartyOrItem)
